module.exports = __webpack_public_path__ + "img/liverpool.0b2a2937.png";